import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { UserStateName } from '@frontend/user/types';
import React from 'react';

import useUserStateSelectV2 from './user-state-select-v2.controller';

const ID = 'user-state-select-v2';

export interface UserStateSelectV2Props extends Omit<SelectInputV2Props<UserStateName>, 'options'> {
    subset?: string[];
    includeAnyState?: boolean;
    anyStateLabel?: string;
    anyStateDisplay?: React.ReactNode;
}

export const UserStateSelectV2 = (props: UserStateSelectV2Props) => {
    const viewProps = useUserStateSelectV2(props);
    return (
        <SelectInputV2<UserStateName>
            {...props}
            id={ID + props.id}
            className='w-full'
            label={props.label || CommonMessage.OBJECTS.COMMON_FIELDS.STATUS}
            options={viewProps.options}
        />
    );
};
